import { FOCO_VISIVEL } from 'utils/foco';

/** Catálogo sem itens no ciclo (CAT-12, VIG-08): o texto cobre período fechado e pontuação insuficiente. */
export default function SemExperiencias() {
  return (
    <section aria-label="Experiências do ciclo" className="mb-6">
      <p role="status" tabIndex={0} className={`m-0 rounded-xl bg-brand-white px-6 py-5 text-[14px] leading-[1.6] text-content shadow-jj-01 ${FOCO_VISIVEL}`}>
        Colega, não há experiências disponíveis para você neste ciclo no momento. O período de escolha pode ainda não ter
        começado, ou você pode não ter atingido a pontuação mínima do ciclo. Fique tranquilo: você receberá seus pontos
        Livelo normalmente, desde que cumpridos os requisitos previstos na IN 403.
      </p>
    </section>
  );
}
